import { HTTPClient } from "../common/HTTPClient";

import { PaginationRequestParams } from "@/common/mixins/pagination";

export interface ShopifyCreateRequestParams {
  shopId: number;
  shopName: string;
  token: string;
  hostname: string;
  mcApiKey: string;
  mcSecretkey: string;
  deliveryModeId: number;
}

export interface ShopifyUpdateRequestParams {
  shopName: string;
  token: string;
  hostname: string;
  mcApiKey: string;
  mcSecretkey: string;
  deliveryModeId: number;
}

export interface ShopifyDeleteRequestParams {
  id: number;
}

export class ShopifyClient {
  constructor(private httpClient: HTTPClient) {}

  public async postShopify(params: ShopifyCreateRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/shops-shopify",
      method: "POST",
      data: params
    });

    return data;
  }

  public async getShopify(params: PaginationRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/shops-shopify",
      method: "GET",
      params
    });

    return data;
  }

  public async getShopifyById(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/shops-shopify/${id}`,
      method: "GET"
    });

    return data;
  }

  public async patchShopify(
    id: number,
    params: ShopifyUpdateRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/shops-shopify/${id}`,
      method: "PATCH",
      data: params
    });

    return data;
  }

  public async deleteShopify(params: ShopifyDeleteRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/shops-shopify/${params.id}`,
      method: "DELETE"
    });

    return data;
  }

  public async postShopifyProductSyncByShopId(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/shopify/shop/${id}/product/sync`,
      method: "POST"
    });

    return data;
  }

  public async postShopifyStockSyncByShopId(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/shopify/shop/${id}/stock/sync`,
      method: "POST"
    });

    return data;
  }
}
